import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import AddToWishList from './widget/component/AddToWishList';

const initSpecificPageWidgets = () => {
    const props = {
        endpoints,
    };

  initWidget('add-to-wish-list', AddToWishList, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpecificPageWidgets.bind(this));
} else {
    initSpecificPageWidgets();
}